import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-in-page-icon/jb-in-page-icon.css.ts
var jb_in_page_icon_css_default = i`:host{color:inherit;display:inline-block;height:var(--icon-size, 18px);width:var(--icon-size, 18px)}`;

export {
  jb_in_page_icon_css_default
};
